import { Trans, useTranslation } from 'react-i18next';
import OrganizationSection2Image from '../../assets/organization_section2_image.svg';
import OrganizationSection2ImageCha from '../../assets/organization_section2_image_cha.svg';
import OrganizationSection2ImageEng from '../../assets/organization_section2_image_eng.svg';
import OrganizationSection2ImageMobile from '../../assets/organization_section2_image_mobile.svg';
import OrganizationSection2ImageMobileCha from '../../assets/organization_section2_image_mobile_cha.svg';
import OrganizationSection2ImageMobileEng from '../../assets/organization_section2_image_mobile_eng.svg';
import { CenterLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H3 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const OrganizationChartSection2 = () => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : pxToRem(108)} />
      <H3><Trans i18nKey='효율과 전문성을 갖춘 통합 조직 체계'/></H3>
      <BTBox height={10} />
      <Body1 style={{opacity: 0.5}}>{t('비비테크의 성장을 이끄는 조직 체계를 소개합니다.')}</Body1>
      <BTBox height={isMobile ? 53 : 160} />
      <CenterLayout>
        <img src={isMobile ? (isEng ? OrganizationSection2ImageMobileEng : isChina ? OrganizationSection2ImageMobileCha : OrganizationSection2ImageMobile) : isEng ? OrganizationSection2ImageEng : isChina ? OrganizationSection2ImageCha : OrganizationSection2Image} style={{ width: '100%', maxWidth: '1600px' }} />
      </CenterLayout>
      <BTBox height={isMobile ? 147 : 250} />
    </VerticalLayout>
  );
};

export default OrganizationChartSection2;
